import React, { useState } from "react";
import Image from "next/image";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import styles from "../../styles/shap_of_you.module.scss";
import shapesenco from "../../assets/images/shapesenco.png";
import { MobileNavigationProps } from "./types";

const AboutScreen: React.FC<MobileNavigationProps> = ({
  navigateToStep,
  isAuthenticated,
}) => {
  const [loading, setLoading] = useState(false);

  // Handle "Start Experience" button click with consent checking
  const handleStartExperience = async () => {
    setLoading(true);

    try {
      if (isAuthenticated) {
        // User is authenticated - check consent status via API
        const { data } = await httpClient.get(
          endpoints.auth.getConsentForm()
        );

        if (data.statusText === "accepted") {
          // Scenario 1: Consent already accepted - skip TC, go to welcome
          console.log("Consent already accepted, skipping TC screen");
          navigateToStep("welcome");
        } else {
          // Scenario 2: Consent rejected - show TC screen
          navigateToStep("tc");
        }
      } else {
        // Scenario 3: User is NOT authenticated - go to TC without API call
        navigateToStep("tc");
      }
    } catch (error) {
      console.error("Error checking consent status:", error);
      // If API fails, show TC screen anyway
      navigateToStep("tc");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="d-md-none w-100">
      <div className={styles.wrapper_about}>
        {/* Header */}
        <div className={styles.wrapper_sec}>
          <header className={styles.header}>
            <Image src={shapesenco} alt="Logo" />
          </header>

          {/* Video Card */}
          <div className={styles.videoCard}>
            <video
              width="100%"
              height="auto"
              controls
              autoPlay={false}
              muted
              loop
            >
              <source
                src="https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/Shape_Of_You_Story_6.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Content */}
          <div className={styles.content}>
            <h2>Jewellery That Matches Your Face Shape</h2>

            <p>
              Every face tells its own story, and the jewellery you wear should
              reflect that individuality. Understanding the shape of your face
              is the key to selecting pieces that not only complement your
              natural features but elevate them with effortless elegance. With
              Shape of You, Senco&apos;s innovative expert styling approach, you
              can now discover jewellery designs tailored to your unique
              contours and personality. From earrings that refine angles to
              necklaces that balance proportions, each recommendation is chosen
              with intention. Because the perfect jewellery does more than
              accessorise - it highlights confidence, enhances beauty, and above
              all, celebrates you.
            </p>
          </div>
        </div>
        {/* CTA */}
        <div className={styles.cta_btn_container}>
          <button
            className={styles.ctaBtn}
            onClick={handleStartExperience}
            disabled={loading}
            style={
              loading
                ? {
                    background: "#d3d3d3",
                    color: "#888",
                    cursor: "not-allowed",
                    opacity: 0.6,
                  }
                : {}
            }
          >
            {loading ? "Loading..." : "Start Experience →"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutScreen;
